var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 140 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #7e3eec;\n      }\n\n      .cls-2 {\n        fill: #7d3cec;\n      }\n\n      .cls-3 {\n        fill: #7d3bec;\n      }\n\n      .cls-5 {\n        fill: #7e3dec;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M79.61,84.47c-.12,4.69-2,10.81-7.62,10.82l-50.93.14c-6.63.02-8.86-4.57-9.25-10.42-.87-13.14,8.66-24.09,22.22-23.34,7.62,3.78,16.24,3.56,23.93-.11,12.79-.13,21.98,9.82,21.64,22.9Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 45.67,
    cy: 36.36,
    r: 19.63
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M123.79,84.22c-1.43,3.29-4.64,5.53-7.79,5.53h-31.18c1.14-9.84-.33-17.66-6.5-25.19,3.79-2.84,8.28-3.29,13.18-2.01,3.97,1.04,8.36-.1,12.53-.49,12.17-1.16,21.83,9.93,19.77,22.15Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 96.16,
    cy: 39.12,
    r: 16.86
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkup);
export default __webpack_public_path__ + "static/media/linkup.4a09ac3be4411e5c6e8c8caf4540545f.svg";
export { ForwardRef as ReactComponent };